export const CONFIRMATION_TEST_ID = {
  receiptLink: 'confirmation-receipt',
  receiptDineInLink: 'receipt-dine-in-link',
  merchantName: 'merchant-name',
  merchantAddress: 'merchant-address',
  customerAddress: 'customer-address',
  merchantPhone: 'merchant-phone',
  redirectToGiftCardsBtn: 'get-another-gift-card-link',
  placeAnotherOrderBtn: 'place-another-order-button',
  wantSomethingElseText: 'want-something-else-text',
  dineInText: 'dine-in-text',
  deliveryText: 'delivery-text',
  mapElement: 'map',
  cmaHandoff: 'cma-handoff'
};
